// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/phone.js';

import { paths } from '../generated/phone';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('phone', Original, paths);
